import { Link, Navigate } from 'react-router-dom'
import { Compass, Sparkles, FileDown, WifiOff } from 'lucide-react'
import { useAuth } from '../auth/useAuth'
import { Button } from '../../shared/components/Button'
import { Spinner } from '../../shared/components/Spinner'

export function Welcome() {
  const { status } = useAuth()

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-st-bg">
        <Spinner label="Loading…" />
      </div>
    )
  }
  if (status === 'authenticated') return <Navigate to="/" replace />

  return (
    <div className="min-h-screen bg-st-bg">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-6 py-20 text-center">
        <span className="mb-6 flex h-16 w-16 items-center justify-center rounded-st-lg bg-st-primary text-white">
          <Compass className="h-8 w-8" />
        </span>
        <h1 className="font-display text-4xl font-bold text-st-text md:text-5xl">
          Your living trip container
        </h1>
        <p className="mt-4 max-w-xl text-lg text-st-muted">
          Plan with AI, navigate your days, keep documents close, and remember every journey —
          all in one calm, shared place.
        </p>

        <div className="mt-8">
          <Link to="/login">
            <Button variant="accent" className="px-6 text-base">
              Get started
            </Button>
          </Link>
        </div>

        <div className="mt-16 grid w-full gap-4 sm:grid-cols-3">
          <Feature Icon={Sparkles} title="Plan with AI" text="Describe your trip and get a draft route to refine." />
          <Feature Icon={FileDown} title="Export a PDF" text="Turn any trip into a clean, printable itinerary." />
          <Feature Icon={WifiOff} title="Works offline" text="Your active trip and today’s docs stay available." />
        </div>
      </div>
    </div>
  )
}

function Feature({ Icon, title, text }: { Icon: typeof Compass; title: string; text: string }) {
  return (
    <div className="rounded-st-lg border border-st-line bg-st-surface p-5 text-left">
      <Icon className="h-6 w-6 text-st-primary" />
      <h3 className="mt-3 font-medium text-st-text">{title}</h3>
      <p className="mt-1 text-sm text-st-muted">{text}</p>
    </div>
  )
}
